import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6bf305b6")

_pushScopeId("data-v-6bf305b6")
const _hoisted_1 = { class: "card-content" }
const _hoisted_2 = { class: "media" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "media-left" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon is-medium" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-lg fa-calendar-day" })
  ])
], -1)
const _hoisted_4 = { class: "media-content" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "title is-size-5 mb-0" }
const _hoisted_7 = {
  key: 0,
  class: "checkbox",
  disabled: ""
}
const _hoisted_8 = /*#__PURE__*/_createVNode("input", {
  type: "checkbox",
  value: "check",
  disabled: "",
  checked: ""
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Remote ")
const _hoisted_10 = {
  key: 0,
  class: "card-footer"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Edit")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "has-text-danger"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-spinner fa-pulse" })
], -1)
const _hoisted_14 = {
  key: 1,
  class: "icon-text has-text-grey-dark"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "Delete", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", {
    class: ["card", { 'card--editable': _ctx.editable }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.dayTemplate.name), 1),
            (_ctx.dayTemplate.remote)
              ? (_openBlock(), _createBlock("label", _hoisted_7, [
                  _hoisted_8,
                  _hoisted_9
                ]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dayTemplate.periods.split(','), (period) => {
            return (_openBlock(), _createBlock("div", {
              key: period,
              textContent: _toDisplayString(period)
            }, null, 8, ["textContent"]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.editable)
      ? (_openBlock(), _createBlock("footer", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: _ctx.editLink,
            class: "card-footer-item has-text-info"
          }, {
            default: _withId(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode("a", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeTemplate && _ctx.removeTemplate(...args)), ["prevent"])),
            class: "card-footer-item"
          }, [
            (_ctx.isDeleting)
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  _hoisted_13
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _hoisted_16
                ]))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
})